import axios, {AxiosInstance} from 'axios';
import {config} from '../config';
import {Verify} from '../public/verify';
import {Consent} from '../public/SubmitConsentForm';
import {Upload} from '../public/Upload';


export class IIUMLuxtagBase {
  private readonly instance: AxiosInstance;

  public constructor() {
    this.instance = axios.create(config);
  }

  public verify() {
    return new Verify(this.instance);
  }

  public consent() {
    return new Consent(this.instance);
  }

  public upload() {
    return new Upload(this.instance);
  }
}
